export const HOME = "/";
export const APPLICATION = "/apply";
